exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__ScoutingMap__pin__-bhs- svg {\n  height: 100%;\n  left: 25%;\n  position: absolute;\n  top: -50%;\n  width: 100%;\n}\n\n.dmb-web__ScoutingMap__enhancedPin__rhui8 svg {\n  height: 68px;\n  width: 48px;\n  top: -85%;\n  left: 30%;\n  position: absolute;\n}\n", ""]);

// exports
exports.locals = {
	"pin": "dmb-web__ScoutingMap__pin__-bhs-",
	"enhancedPin": "dmb-web__ScoutingMap__enhancedPin__rhui8"
};